import { RoleRegistryEntry } from 'src/common/roleRegistry/roleRegistry';
import {
  getGroupRetentionCallout,
  getRoleDefinition,
} from 'src/common/roleRegistry/roleRegistryHelpers';

export type CalloutTone = 'info' | 'warning';

export interface RoleChangeCallout {
  tone: CalloutTone;
  message: string;
}

export const deriveRoleChangeCallouts = (
  fromRole: string
): RoleChangeCallout[] => {
  const fromRoleEntry: RoleRegistryEntry | undefined =
    getRoleDefinition(fromRole);

  if (!fromRoleEntry) {
    return [];
  }

  const callouts: RoleChangeCallout[] = [
    {
      tone: 'info',
      message: getGroupRetentionCallout(fromRoleEntry.group),
    },
  ];

  if (fromRoleEntry.leaveWarning) {
    callouts.push({
      tone: 'warning',
      message: fromRoleEntry.leaveWarning,
    });
  }

  return callouts;
};
